import styled from 'styled-components';

const SwitchListItem = styled.div<{ dragging: boolean }>`
    padding: 0.5rem;
    border: 1px solid #d9d9d9;
    &:not(:last-child) {
        margin-bottom: -1px;
    }

    &:focus {
        outline: none;
        border: 1px solid #ccc;
    }

    ${({ dragging }) => {
        return dragging
            ? `
                .ant-switch {
                    display: none;
                }
            `
            : '';
    }}
`;

const Handle = styled.div`
    color: rgba(0, 0, 0, 0.65);
    padding: 5px 8px 5px 5px;
    cursor: pointer;

    svg {
        display: block;
        width: 12px;
        height: auto;
        fill: currentColor;
    }
`;

export { Handle, SwitchListItem };
